import { GridCellProps } from '@progress/kendo-react-grid';
import { SyntheticEvent, useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { round } from 'src/utils/number';
import { useContextSelector } from 'use-context-selector';
import { ShoppingListProductsContext } from '../ShoppingListProductsContext';
import ParNumericInput from './ParNumericInput';

const ShoppingListParCell = (props: GridCellProps) => {
  const field = props.field || '';
  const value = props.dataItem[field] ?? 0;
  const { dataItem, dataIndex, onChange } = props;
  const parDisplayValue = useMemo(
    () => String(round(Number(value) || 0, 2)),
    [value]
  );
  const isParEditable = useContextSelector(
    ShoppingListProductsContext,
    (context) => context.isParEditable
  );

  const handleParChange = useCallback(
    (e: SyntheticEvent, newValue: number) => {
      onChange?.({
        dataIndex,
        dataItem,
        field,
        syntheticEvent: e,
        value: newValue,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  return (
    <GridCellBase
      {...props}
      disableToolTip
      rowSelectionEnabled={false}
      className="!p-0 w-[100%]"
    >
      {isParEditable ? (
        <ParNumericInput value={value} onChange={handleParChange} className="w-[100%]" />
      ) : (
        <span data-tooltip-id="global-tooltip" data-tooltip-content={parDisplayValue}>
          {parDisplayValue}
        </span>
      )}
    </GridCellBase>
  );
};

export default ShoppingListParCell;
